import * as React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Button,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import Images from '../Utils/images';
import { useEffect, useState, useMemo } from 'react';
import store, { RootState, useAppSelector } from '../redux/store';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/authSlice';
import { logout as chatLogout } from '../Pages/Chats/chat.slice';
import { resetAuthorizationToken } from '../api';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Logout,
  getAccessControlData,
  setAccordion,
  setCommonMenu,
  getUnreadCount,
} from '../redux/commonSlice';
import { getCart } from '../redux/cart.slice';
import { auth } from '../Utils/firebaseConfig';
import { signOut } from 'firebase/auth';
import SelectAddressDialog from '../Pages/Store/Components/SelectAddressDialog';
import InAppNotification from '../Components/InAppNotification';
import { ROUTES } from '../helpers/contants';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountControl from '../Pages/Profile/Modals/AccountControl';
import WarningDialog from '../Components/WarningDialog';
import { useSocket } from '../Pages/Chats/SocketContext';
import CustomButton from '../Components/CustomButton';
import DraftModal from '../Pages/Risk/components/AddThreat/DraftModal';
import { usePermissions } from '../hooks/usePermissions';

export default function Header(): JSX.Element {
  const { disconnect: disconnectSocket } = useSocket();
  const dispatch = useDispatch();
  const locaiton: any = useLocation();
  // const count = useRenderCount()
  const navigate = useNavigate();

  const MemomisePopUp = useMemo(() => <InAppNotification />, []);

  const { cartDetails } = useAppSelector((state: RootState) => state.cart);
  const { UserListSignUp, permissionsData } = useAppSelector(
    (state: RootState) => state.common,
  );
  // console.log(userlist,'userlist')
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const [addressOpen, setAddressOpen] = useState(false);
  const [openAccControl, setOpenAccControl] = useState(false);
  const [warningOpen, setWarningOpen] = useState(false);
  const [draftOpen, setDraftOpen] = useState(false);

  const { selectedAddress, profileData, menu, accordian, loggedInMemberType } =
    useAppSelector((state: RootState) => state.common);

  const location = useLocation();
  const handleCloseAddress = () => {
    'calling this method';
    setAddressOpen(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  useEffect(() => {
    if (profileData) {
      localStorage.setItem('userDetails', JSON.stringify(profileData));
    }
  }, [profileData]);

  useEffect(() => {
    store.dispatch(setCommonMenu(false));
    dispatch(setAccordion(false));
    document.body.classList.remove('body-freeze');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // console.log(userlist?.userlist?.profilePicture, 'what is this')

  // console.log(UserListSignUp, 'userDatanew')

  useEffect(() => {
    getCart();
    getAccessControlData();
  }, []);

  // const removeRecaptcha = () => {
  //   document
  //     .querySelectorAll("div[style*='z-index: 2000000000']")
  //     .forEach((el) => el.remove())
  //   document
  //     .querySelectorAll("iframe[src*='recaptcha']")
  //     .forEach((el) => el.remove())
  // }

  const handleClose = async (action?: 'logout' | 'otherAction') => {
    if (action === 'logout') {
      await signOut(auth);
      // ✅ Fully reset reCAPTCHA before logout
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;

        console.log('working herere', window.recaptchaVerifier);
      }
      try {
        // ✅ Sign out from Firebase
        await signOut(auth);
        // ✅ Fully reset reCAPTCHA before logout
        if (window.recaptchaVerifier) {
          window.recaptchaVerifier.clear();
          window.recaptchaVerifier = null;

          console.log('working herere');
        }

        // Preserve tokenFCM while clearing everything else
        const tokenFCM = localStorage.getItem('tokenFCM');

        // Clear all localStorage items
        localStorage.clear();

        // Restore tokenFCM if it existed
        if (tokenFCM) {
          localStorage.setItem('tokenFCM', tokenFCM);
          console.log('🔑 Preserved tokenFCM during logout');
        }
        sessionStorage.clear();
        // logOutMethod()

        // ✅ Dispatch logout action & reset authorization
        dispatch(logout());
        dispatch(chatLogout());
        resetAuthorizationToken();
        disconnectSocket();

        // ✅ Provide user feedback
        console.log('User logged out successfully.');
      } catch (error) {
        console.error('Error during logout:', error);
      }
    }

    // ✅ Close any open menus or dialogs
    setAnchorEl(null);
    setExpanded('');
  };

  function calculateProductCount(cartData: any) {
    if (!cartData || !Array.isArray(cartData.cart)) {
      return 0;
    }

    let totalProductCount = 0;

    cartData.cart.forEach((cartItem: any) => {
      if (Array.isArray(cartItem.groupedProducts)) {
        cartItem.groupedProducts.forEach((group: any) => {
          if (Array.isArray(group.products)) {
            totalProductCount += group.products.length;
          }
        });
      }
    });
    // setCount(totalProductCount)

    return totalProductCount;
  }

  // console.log('Header', count)
  useEffect(() => {
    getUnreadCount();
  }, []);

  const [isScrolled, setIsScrolled] = useState(false);

  // Function to check if the page is scrolled
  const handleScroll = () => {
    if (window.scrollY > 0) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  // Adding the scroll event listener on component mount
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array means this effect runs only once on mount

  const handleNavigation = (event: React.MouseEvent) => {
    event.preventDefault(); // Prevent default anchor behavior
    navigate('/store#download-app', { replace: true });

    setTimeout(() => {
      const section = document.getElementById('download-app');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const [expanded, setExpanded] = React.useState<string | false>('');

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const role = permissionsData?.[0] ?? null;
  const memberType = loggedInMemberType ?? null;

  const permissions = usePermissions(role, memberType);

  const REGISTRATION_ROUTES = [
    '/select-department',
    '/select-position',
    '/profile-photo',
  ];

  const isRegistrationPending = REGISTRATION_ROUTES.includes(location.pathname);

  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    // User has not completed registration
    if (isRegistrationPending) {
      e.preventDefault();

      console.log('Complete registration first');

      return;
    }

    // Allow navigation
    navigate('/');
  };

  return (
    <>
      <header className={isScrolled ? 'header scrolled' : 'header'}>
        <div className="d-flex align-center">
          <div className="mobile_menu">
            {locaiton?.pathname !== '/select-department' &&
              locaiton?.pathname !== '/select-position' &&
              locaiton?.pathname !== '/profile-photo' && (
                <IconButton
                  color="primary"
                  onClick={() => {
                    const isMenuCurrentlyOpen = menu;
                    store.dispatch(setCommonMenu(!menu));
                    // Only setAccordion when menu is being closed

                    const newMenuState = !menu;

                    // Toggle body class
                    if (newMenuState) {
                      document.body.classList.add('body-freeze');
                    } else {
                      document.body.classList.remove('body-freeze');
                    }
                    if (!isMenuCurrentlyOpen) {
                      dispatch(
                        setAccordion(
                          locaiton?.pathname.includes('store')
                            ? 'Store'
                            : locaiton?.pathname.includes('my')
                            ? 'Project'
                            : false,
                        ),
                      );
                    } else {
                      dispatch(setAccordion(false));
                    }
                  }}
                >
                  {/* <MenuIcon /> */}
                  <i className="ham-icon"></i>
                </IconButton>
              )}
          </div>

          {locaiton?.pathname === '/select-department' ||
          locaiton?.pathname === '/select-position' ||
          locaiton?.pathname === '/profile-photo' ? (
            <div className="ml-40"></div>
          ) : null}

          <Link to="/" className="logo" onClick={handleLogoClick}>
            <img src={Images.LogoNew} alt="Logo" />
          </Link>

          {/* {locaiton?.pathname !== '/select-department' &&
            locaiton?.pathname !== '/select-position' &&
            location?.pathname !== '/profile-photo' &&
            location?.pathname !== '/select-department' &&
            location?.pathname !== '/select-position' && (
              <Link to="/store#download-app" className="get-app">
                <i className="mobile-icon mr-8"></i>
                <p className="MuiTypography-body2">Get the App</p>
              </Link>
            )} */}
          {/* {locaiton?.pathname !== '/search' &&
            locaiton?.pathname !== '/select-department' &&
            locaiton?.pathname !== '/select-position' &&
            locaiton?.pathname !== '/profile-photo' &&
            !locaiton?.pathname.includes('store') &&
            !locaiton?.pathname.includes('spendings') && (
              <div className="header-search">
                <SearchField
                  className="sm round"
                  onSearch={() => navigate(ROUTES.SEARCH)}
                />
              </div>
            )} */}

          {(locaiton?.pathname === '/risk-center' ||
            locaiton?.pathname?.includes('security')) && (
            <div className="threat-header-btns">
              {/* <CustomButton
                variant="contained"
                color="error"
                size="small"
                width="100%"
                text={'Emergency'}
                showIcon={true}
                icon={Images.UrgentSmIcon}
                iconPosition="start"
                id={''}
                className="round"
              ></CustomButton> */}

              {!permissions?.canEdit('riskCentrePermission') ? null : (
                <CustomButton
                  variant="contained"
                  size="small"
                  width="100%"
                  text={'NEW THREAT REPORT'}
                  showIcon={true}
                  icon={Images.PageSmWhiteIcon}
                  iconPosition="start"
                  onClick={() =>
                    navigate(`${ROUTES.ADD_THREAT}${location.search}`)
                  }
                  id={''}
                  className=""
                ></CustomButton>
              )}
              {!permissions?.canEdit('riskCentrePermission') ? null : (
                <CustomButton
                  variant="lite"
                  size="small"
                  width="100%"
                  text={'SAVED DRAFTS'}
                  showIcon={true}
                  icon={Images.PageSmIcon}
                  iconPosition="start"
                  onClick={() => setDraftOpen(true)}
                  id={''}
                  className=""
                ></CustomButton>
              )}
              <CustomButton
                variant="contained"
                size="small"
                width="100%"
                text={'THREAT MONITOR REQUEST'}
                // showIcon={true}
                // icon={Images.PageSmWhiteIcon}
                // iconPosition="start"
                onClick={() =>
                  window.open('https://risksubmit.web.app/request', '_blank')
                }
                id={''}
                className=""
              ></CustomButton>
              <CustomButton
                variant="contained"
                size="small"
                width="100%"
                text={'PERSONNEL TRACKER'}
                // showIcon={true}
                // icon={Images.PageSmWhiteIcon}
                // iconPosition="start"
                onClick={() =>
                  window.open('https://client.reeltrak.com/', '_blank')
                }
                id={''}
                className=""
              ></CustomButton>
            </div>
          )}
        </div>

        <div className="authAction">
          <div className="sm-lower-actions">
            {location.pathname === '/store' && (
              <button
                className="header-location"
                onClick={() => setAddressOpen(true)}
              >
                <i className="pin-icon"></i>
                <p className="MuiTypography-subtitle1">
                  {selectedAddress?.productionName
                    ? `${selectedAddress?.productionName}, ${selectedAddress?.setName}, ${selectedAddress?.locationName}`
                    : selectedAddress?.locationName || ''}
                </p>
                <i className="arrow-down-icon ml-auto"></i>
              </button>
            )}
          </div>

          {/* Cart and Notification Icons - Moved to be next to profile */}
          <div className="header-actions">
            {locaiton?.pathname !== '/select-department' &&
              locaiton?.pathname !== '/select-position' &&
              location?.pathname !== '/profile-photo' &&
              location?.pathname !== '/select-department' &&
              location?.pathname !== '/select-position' && (
                <IconButton
                  className="cart-btn"
                  onClick={() => {
                    navigate('/cart', {
                      replace: location.pathname === '/preview-shift',
                    });
                  }}
                  sx={{
                    padding: '9px 12px',
                  }}
                >
                  <i className="cart-white-icon"></i>
                  {calculateProductCount(cartDetails) > 0 ? (
                    <span className="count">
                      {cartDetails?.cart && cartDetails?.cart?.length
                        ? calculateProductCount(cartDetails)
                        : 0}
                    </span>
                  ) : null}
                </IconButton>
              )}

            {/* Notification Icon */}
            {locaiton?.pathname !== '/select-department' &&
              locaiton?.pathname !== '/select-position' &&
              location?.pathname !== '/profile-photo' &&
              location?.pathname !== '/select-department' &&
              location?.pathname !== '/select-position' &&
              MemomisePopUp}
          </div>

          {locaiton?.pathname !== '/profile-photo' &&
            location?.pathname !== '/select-department' &&
            location?.pathname !== '/select-position' && (
              <>
                <Button
                  id="basic-button"
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                  className="profile-open-btn"
                >
                  <div className="userDropdown">
                    <Avatar
                      alt="User name"
                      src={
                        // userDetails?.profilePicture
                        //   ? userDetails?.profilePicture
                        //   : Images.AUTH_BG_1
                        UserListSignUp?.profilePicture ||
                        profileData?.profilePicture
                          ? UserListSignUp?.profilePicture ||
                            profileData?.profilePicture
                          : Images.Image_Placegolder
                      }
                    />
                    {/* IN CASE OF NO IMAGE AVAULABLE */}
                    {/* <Avatar>H</Avatar> */}
                    <div className="info">
                      <h4>
                        {profileData?.firstName} {profileData?.lastName}
                      </h4>
                      <p>{profileData?.email}</p>
                    </div>
                    {/* {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />} */}
                    {open ? (
                      <img src={Images.Arrow_Up} alt="Arrow" />
                    ) : (
                      <img src={Images.ARROW_DOWN} alt="Arrow" />
                    )}
                  </div>
                </Button>
                <Menu
                  id="user-menu"
                  className="profile-dropdown"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'user-button',
                  }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      navigate(ROUTES.PROFILE);
                    }}
                  >
                    My Profile
                  </MenuItem>
                  {/* <MenuItem onClick={() => handleClose('')}>My account</MenuItem> */}
                  <div className="MuiButtonBase-root">
                    <Accordion
                      elevation={0}
                      expanded={expanded === 'panel1'}
                      onChange={handleChange('panel1')}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                      >
                        Help
                      </AccordionSummary>
                      <AccordionDetails>
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            navigate(ROUTES.PRIVACY_POLICY);
                          }}
                          className="text-text"
                        >
                          Privacy Policy
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            navigate(ROUTES.TERMS_CONDITION);
                          }}
                          className="text-text"
                        >
                          Terms of Use
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            navigate(ROUTES.FAQ_PAGE);
                          }}
                          className="text-text"
                        >
                          FAQ's
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            navigate(ROUTES.CONTACT_US);
                          }}
                          className="text-text"
                        >
                          Contact Us
                        </MenuItem>
                      </AccordionDetails>
                    </Accordion>
                  </div>

                  <div className="MuiButtonBase-root">
                    <Accordion
                      elevation={0}
                      expanded={expanded === 'panel2'}
                      onChange={handleChange('panel2')}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                      >
                        Settings
                      </AccordionSummary>
                      <AccordionDetails>
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            setOpenAccControl(true);
                          }}
                          className="text-text"
                        >
                          {' '}
                          Account Control
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            setWarningOpen(true);
                          }}
                          className="text-text"
                        >
                          {' '}
                          Delete Account
                        </MenuItem>
                      </AccordionDetails>
                    </Accordion>
                  </div>

                  <MenuItem
                    onClick={() => {
                      handleClose('logout');
                      Logout();
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </>
            )}
        </div>
      </header>

      {location.pathname === '/store' && (
        <SelectAddressDialog
          handleClose={handleCloseAddress}
          open={addressOpen}
          type="cabService"
          pickupType={'pickup'}
        />
      )}
      <AccountControl
        open={openAccControl}
        handleClose={() => setOpenAccControl(false)}
      />
      <WarningDialog
        open={warningOpen}
        title="Delete Account"
        description="Are you sure you want to delete Account?"
        type="warning"
        handleClose={() => {
          // handleClose('logout');
          setWarningOpen(false);
        }}
        onClick={() => {
          handleClose('logout');
          Logout();
        }}
        cancelBtnText="Cancel"
        confirmBtnText="Yes, I'm Sure"
        showIcon={false}
      />
      <DraftModal open={draftOpen} onClose={() => setDraftOpen(false)} />
    </>
  );
}
